import React, { useCallback, useMemo } from 'react'

import { Select } from '../index'

const typeToLabel = type => {
  switch (type) {
    case 'cooking':
      return 'Cooking'
    case 'preparation':
      return 'Preparation'
    case 'initial':
      return 'Initial'
    case 'final':
      return 'Final'
    default:
      return 'Cooking'
  }
}

const StepSelect = ({ step, steps, name, inverted, onChange, jumpIndex, defaultLocale, disabled }) => {

  const values = useMemo(() => steps.map(s => s === step ? null : ({
    id: s.stepNewKey ? `new,${s.stepNewKey}` : `existing,${s.stepID}`,
    name: `${typeToLabel(s.type)}: ${s.title[defaultLocale]}`,
  })).filter(Boolean), [defaultLocale, step, steps])

  const handleChange = useCallback(e => {
    const selectValue = e.target.value
    if (selectValue) {
      const pair = selectValue.split(',')
      const field = pair[0] === 'new' ? `stepJump${jumpIndex}NewKey` : `stepJump${jumpIndex}ID`
      const value = pair[0] === 'new' ? pair[1] : parseInt(pair[1], 10)
      onChange({
        target: {
          value,
          name: `${name}.${field}`,
        },
      }, model => {
        if (pair[0] === 'new') {
          delete step[`stepJump${jumpIndex}ID`]
        } else {
          delete step[`stepJump${jumpIndex}NewKey`]
        }
        return model
      })
    } else {
      delete step[`stepJump${jumpIndex}NewKey`]
      delete step[`stepJump${jumpIndex}ID`]
      onChange({
        target: {
          value: undefined,
          name: `${name}.stepJump${jumpIndex}NewKey`,
        },
      })
    }
  }, [jumpIndex, name, onChange, step])

  const select = useCallback(() => ({
    onChange: handleChange,
    value: step[`stepJump${jumpIndex}NewKey`] ? `new,${step[`stepJump${jumpIndex}NewKey`]}` : `existing,${step[`stepJump${jumpIndex}ID`]}`,
  }), [handleChange, jumpIndex, step])

  return (
    <Select {...{
      name,
      select,
      title: `Step Jump ${jumpIndex}`,
      values: values,
      inverted,
      disabled,
    }} />
  )
}

export default StepSelect
